import ImageLogin from '@/assets/image_login.png';
import Logo from '@/assets/logo/logo.svg';
import { FieldError } from 'react-hook-form';

import { Button, TextField } from '../Common';
import { TextfieldType } from '../Common/TextField/TextField.types';
import { useLoginForm } from '@/hooks/useLoginForm';

export const LoginForm = () => {
  const {
    register,
    handleSubmit,
    errors,
    isPending,
    showTextPassword,
    togglePasswordVisibility,
    onSubmit,
  } = useLoginForm();

  return (
    <div className="w-full bg-bg_login bg-cover bg-no-repeat">
      <div className="h-screen w-full max-w-[1512px] mx-auto">
        <div className="flex flex-col lg:flex-row h-full">
          <div className="lg:w-[75%] w-full h-[20vh] lg:h-full relative">
            <img
              src={ImageLogin}
              alt="Jeunes étudiants souriants"
              className="hidden lg:block w-full h-full object-cover"
            />
            <div className="absolute top-5 left-5">
              <div className="bg-black size-[90px] rounded-full flex items-center justify-center">
                <img
                  src={Logo}
                  alt="Logo"
                  className="w-[67.81px] h-[50.86px] object-cover"
                />
              </div>
            </div>
          </div>

          <div className="lg:w-[554px] w-full flex items-center justify-center relative p-6 lg:p-0">
            <div className="w-full max-w-[554px] bg-secondary text-white rounded-lg p-6 lg:p-10 shadow-lg lg:relative left-0 lg:left-[-150px] h-[460px]">
              <div className="mb-8">
                <h1 className="text-[42px] leading-[27.3px] font-semibold text-center mb-2 text-primary">
                  Bienvenue
                </h1>
                <p className="text-white text-center text-sm lg:text-[14.7px] leading-[25.2px] mt-[24.5px]">
                  Bienvenue ! Veuillez entrer vos identifiants
                </p>
              </div>

              <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                <div className="space-y-2 mb-0 pb-0 h-[85px]">
                  <TextField
                    borderStyle="border-[1.05px] border-solid border-[#616161]"
                    textFieldType={TextfieldType.INPUT}
                    type="text"
                    label="Nom d'utilisateur"
                    name="username"
                    register={register('username')}
                    placeholder="Entrez votre nom d'utilisateur"
                    errorStyle="text-red-500"
                    helpText={(errors.username as FieldError)?.message}
                  />
                </div>

                <div className="space-y-2 h-[85px]">
                  <TextField
                    borderStyle="border-[1.05px] border-solid border-[#616161]"
                    textFieldType={TextfieldType.INPUT}
                    label="Mot de passe"
                    type={showTextPassword ? 'text' : 'password'}
                    register={register('password')}
                    placeholder="Entrez votre mot de passe"
                    icon={
                      showTextPassword ? (
                        <i className="pi pi-eye cursor-pointer text-gray-500"></i>
                      ) : (
                        <i className="pi pi-eye-slash cursor-pointer text-gray-500"></i>
                      )
                    }
                    onClickIcon={togglePasswordVisibility}
                    errorStyle="text-red-500"
                    helpText={(errors.password as FieldError)?.message}
                  />
                </div>

                <Button
                  title={isPending ? 'Connexion...' : 'Connexion'}
                  className="bg-primary w-full h-[50px] hover:outline hover:outline-2 hover:outline-primary"
                  onClick={handleSubmit(onSubmit)}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
